import i18n from '@/i18n'
import {farmService} from '@/services/farm.service'
import {mapActions, mapGetters} from 'vuex'
import {EventHub, SnackbarStyle} from '@/constants/constants'
import {DialogFarm} from "@/tools/dialog"
import TreeSelectorComponent from '@/components/commons/tree-selector/TreeSelectorComponent.vue'
import {clone} from 'ramda'
import {enterpriseService} from "@/services/enterprise.service";
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'FarmDialogComponent',
    components: {
        TreeSelectorComponent,
        AutocompleteComponent
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // model del formulario
        validForm: false,
        // reglas de validación
        validationRules: {
            required: (value) => !!value || `${i18n.t('required')}`,
        },
        // errores para el campo del núm de línea
        nameError: [],
        // model para el dialog
        showEditDialog: false,
        // título del dialog
        editDialogTitle: i18n.t('farm.editDialog.titleNew'),
        // normalizer para el treeselect
        normalizer: (node) => {
            return {
                id: node._id,
                label: node.name,
                children: node.children
            }
        },
        // empresas
        enterprises: [],
        // nombre actual
        actualName: null,
    }),
    computed: {
        ...mapGetters({
            'getBread': 'breadcrumbs/getBread',
        }),
    },
    created() {
        this.actualName = this.model.name
        /**
         * El modelo de datos del diálogo se carga a través del objeto del breadcrumb
         */
        this.unwatch = this.$store.watch(
            (state, getters) => getters['breadcrumbs/getBread'],
            (newBreads) => {
                const lastBreadcrumb = this.getBread[newBreads.length - 1]
                if (!lastBreadcrumb) {
                    this.cancel()
                } else {
                    if (lastBreadcrumb.key === DialogFarm) {
                        if (lastBreadcrumb.model) {
                            const modelData = this.model
                            Object.assign(modelData, lastBreadcrumb.model)
                        }
                    }
                }
            },
            {deep: true})
    },
    async mounted() {
        /**
         * El modelo de datos del diálogo se carga a través del objeto del breadcrumb
         */
        const lastBreadcrumb = this.getBread[this.getBread.length - 1]
        if (!lastBreadcrumb) {
            this.cancel()
        } else {
            if (lastBreadcrumb.key === DialogFarm) {
                if (lastBreadcrumb.model) {
                    const modelData = this.model
                    Object.assign(modelData, lastBreadcrumb.model)
                }
            }
        }

        this.enterprises = await enterpriseService.getAllForSelector()
    },
    beforeDestroy() {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch()
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Mensaje de error cuando el nombre está duplicado
         */
        async nameDuplicatedMethod() {
            if (this.model.name === this.actualName) {
                this.nameError = []
                return true
            }
            const response = await farmService.validateFarmName(this.model.name, this.model.enterpriseId)
            if (response) {
                this.nameError.push(`${i18n.t('farm.duplicate')}`)
                return false
            } else {
                this.nameError = []
                return true
            }
        },
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            if (this.$refs.form) {
                this.$refs.form.reset()
            }
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogFarm)
            this.resetFields()
        },
        /**
         * Guardar
         */
        async save() {

            if (!await this.nameDuplicatedMethod()) return
            const farmDto = this.getFarmDto(this.model.update)
            if (this.model.update) {
                farmService.update(farmDto).then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('farm.successUpdateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitFarm')
                    this.cancel()
                    this.$eventBus.$emit(EventHub.COMMIT_FARM, farmDto)
                })
            } else {
                farmService.create(farmDto).then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('farm.successCreateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitFarm')
                    this.cancel()
                    this.$eventBus.$emit(EventHub.COMMIT_FARM, farmDto)
                })
            }
        },
        /**
         * Genera el DTO para actualizar / crear una finca
         * @param {*} update
         */
        getFarmDto(update = false) {
            const result = {
                name: this.model.name,
                enterpriseId: this.model.enterpriseId
            }
            if (update) {
                result.farmId = this.model.id
                result._id = this.model._id
            }
            return result
        },
        /**
         * Cada vez que se modifica la selección de la empresa, se cargan
         */
        enterpriseSelectedFunction (newValue) {
            this.model.enterpriseId = newValue._id ? newValue._id : newValue;
        },
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler(newModel) {
                if (newModel) {
                    if (newModel.enterprises && newModel.enterprises.length > 0) {
                        this.enterprises = clone(newModel.enterprises)
                    }
                }
            }
        },
    }
}
